module.exports = __webpack_public_path__ + "img/Vault-logo.d90dfaeb.png";